import OptionChainActions from "@redux/feature/Markets/Options/actions/optionChain";
import NewOnEdelActions from "@redux/feature/Markets/Common/actions/NewOnEdel";
import OptionRecActions from "@redux/feature/Markets/Options/actions/OpRecommendation";
import OptionGraphChainActions from "@redux/feature/Markets/Options/actions/OptionChainGraphActions";
import UnderstandingSectionActions from "@redux/feature/Markets/Common/actions/UnderstandingSectionActions";
import HighestOIActions from "@redux/feature/Markets/Options/actions/drivingMarket/highestOI";
import HighestGainerActions from "@redux/feature/Markets/Options/actions/drivingMarket/highestGainer";
import HighestVolumeActions from "@redux/feature/Markets/Options/actions/drivingMarket/highestVolume";
import HighestLoserActions from "@redux/feature/Markets/Options/actions/drivingMarket/highestLoser";
import FnoBanActions from "@redux/feature/Markets/Common/actions/fnoBan";
import BseNseExpiryActions from "@redux/feature/Markets/Options/actions/BseNseExpiry";
export default (function () {
    return {
        option: {
            optionChainActions: new OptionChainActions(),
            newOnEdelActions: new NewOnEdelActions(),
            fnoBanActions: new FnoBanActions(),
            understandingSectionActions: new UnderstandingSectionActions(),
            opRecActions: new OptionRecActions(),
            optionGraphActions: new OptionGraphChainActions(),
            bseNseExpiry: new BseNseExpiryActions(),
        },
        optionDrivingMarkets: {
            highestOI: new HighestOIActions(),
            highestOIGainer: new HighestGainerActions(),
            highestVolumeGroth: new HighestVolumeActions(),
            highestOILosers: new HighestLoserActions(),
        },
    };
});
